type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_PREFIX: Record<LogLevel, string> = {
  debug: '[DEBUG]',
  info: '[INFO]',
  warn: '[WARN]',
  error: '[ERROR]',
};

const BACKEND_LEVELS = new Set<LogLevel>(['warn', 'error']);

function ts(): string {
  return new Date().toISOString();
}

async function sendToBackend(
  level: LogLevel,
  message: string,
  context?: any,
  error?: any,
): Promise<void> {
  try {
    const payload = {
      level,
      message,
      context: context || {},
      error: error instanceof Error ? { name: error.name, message: error.message, stack: error.stack } : error,
    };
    await fetch('/api/logs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch {
  }
}

function log(
  level: LogLevel,
  message: string,
  context?: any,
  error?: any,
): void {
  const prefix = LOG_PREFIX[level];
  const fn = console[level] || console.log;

  if (error instanceof Error) {
    fn(`${prefix} ${ts()} - ${message}`, context || '', error);
  } else {
    fn(`${prefix} ${ts()} - ${message}`, context || '');
  }

  if (BACKEND_LEVELS.has(level) && process.env.NODE_ENV === 'production') {
    sendToBackend(level, message, context, error);
  }
}

const logger = {
  debug: (message: string, context?: any) => log('debug', message, context),
  info: (message: string, context?: any) => log('info', message, context),
  warn: (message: string, context?: any, error?: any) => log('warn', message, context, error),
  error: (message: string, context?: any, error?: any) => log('error', message, context, error),
};

export default logger;
